import React from "react";
import styles from "./ClientsGrid.module.scss";

const ClientsGrid = ({ children }: { children: React.ReactNode }) => (
  <div className={styles.grid}>{children}</div>
);

export default ClientsGrid;
